import {District} from '../ui/components/SearchBarUnit/types';
import {normalizeDistrictKey} from './normalizeDistrictKey';

export const getUniqueDistricts = (districts: District[]): District[] => {
	const seen = new Set<string>();
	return districts.filter(district => {
		const key = normalizeDistrictKey(district?.uf, district?.cidade, district?.bairro);
		if (seen.has(key)) return false;
		seen.add(key);
		return true;
	});
};
